import { forwardRef } from 'react'

import type { NumericInputProps } from './NumericInput'
import NumericInput from './NumericInput'

const NumericInputPerFlag = forwardRef<HTMLInputElement, NumericInputProps>(
  (props: NumericInputProps, ref) => {
    return <NumericInput {...props} ref={ref} />
  }
)

export type { NumericInputProps }

export default NumericInputPerFlag
